import type {ManifestationStatus} from 'services/metadata/types';
import {getManifestationStatusColor} from '../functions';

export const useManifestationStatusColor = (
  status: ManifestationStatus,
): string => getManifestationStatusColor(status);
